// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".active-cat[data-v-7c5d1cbf] .v-card{background-color:var(--active-color);color:#fff}.active-cat[data-v-7c5d1cbf] span{color:var(--active-color)}", ""]);
// Exports
module.exports = exports;
